<template lang="html">
  <div>
    <div class="chat-container">
      <Chat type="large" />
    </div>
    <slot />
    <PageFooter />
  </div>
</template>

<script>
import Chat from '@/components/partials/Chat'
import PageFooter from '@/components/page-footer/PageFooter'

export default {
  components: {
    Chat,
    PageFooter,
  },
  name: 'RootLayout'
}
</script>

<style lang="scss">
  .chat-container {
    position: fixed;
    top: 1rem;
    z-index: 20;
    width: 100%;
    max-width: 600px;
    margin: auto;
  }
</style>
